import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { WebPageSchema, BreadcrumbListSchema } from '@/components/feature/SchemaOrg';
import { categories, featuredArticles, latestArticles } from '@/mocks/home';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const allArticles = [...featuredArticles, ...latestArticles];
  const filteredArticles = allArticles.filter((a) => a.category === currentCategory.slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <>
      <WebPageSchema
        title={`${currentCategory.name} - 奶水动漫`}
        description={currentCategory.description}
        url={`https://www.naishuidongman.com/category/${currentCategory.slug}`}
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://www.naishuidongman.com/' },
          { name: currentCategory.name },
        ]}
      />
      <Navbar />
      <main className="pt-16">
        <section className="w-full px-4 md:px-6 py-10 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <span className="text-foreground-300">/</span>
              <span className="text-foreground-700 font-medium whitespace-nowrap">{currentCategory.name}</span>
            </nav>

            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${currentCategory.icon} text-xl text-primary-500`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-800">{currentCategory.name}</h1>
            </div>
            <p className="text-sm text-foreground-500 pl-13">{currentCategory.description}</p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-3 bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                    cat.slug === currentCategory.slug
                      ? 'bg-primary-500 text-white font-medium'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10">
          <div className="max-w-7xl mx-auto">
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer flex flex-col"
                  >
                    <div className="relative aspect-[16/10] overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      {'isHot' in article && article.isHot && (
                        <span className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                          热门
                        </span>
                      )}
                    </div>
                    <div className="p-5 flex flex-col flex-1">
                      <div className="flex items-center gap-2 mb-3 flex-wrap">
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                      </div>
                      <h2 className="text-base md:text-lg font-heading text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-2 mt-4 flex-wrap">
                        {article.tags.map((tag) => (
                          <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                            #{tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类下暂无内容，敬请期待~</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}